module.exports = __webpack_public_path__ + "img/Nonmotor_sus_1.8f27c780.jpg";